if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });

      this.querySelector('[name="plus"]').addEventListener('click', this.onButtonClick.bind(this));
      this.querySelector('[name="minus"]').addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = Number(this.input.value);
      const step = Number(this.input.step) || 1;

      if (event.currentTarget.name === 'plus') {
        this.input.value = previousValue + step;
      } else if (event.currentTarget.name === 'minus' && previousValue > Number(this.input.min)) {
        this.input.value = previousValue - step;
      }

      console.log('[quantity-input] 変更前:', previousValue, '変更後:', this.input.value);

      this.input.dispatchEvent(this.changeEvent);
    }
  });
}